function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25 42c-.505 6.052-5.378 11-12.012 11S1.482 48.052.976 42c-.728-8.724 5.096-12.517 12.012-9.483C19.176 29.483 25.727 33.276 25 42zM50 41.6c-.484 6.052-5.154 11-11.513 11-6.358 0-11.029-4.948-11.513-11-.698-8.724 4.884-12.517 11.513-9.483 5.93-3.034 12.211.759 11.513 9.483z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 33c5.236-9.142 9.28-19.189 11-31 1.89 12.147 17.487 21.117 14.487 30.117"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.5 2c3.533 2.652 4.673 8.287 12.5 6 4.777-1.5 14.223-1.5 19 12-14 1-17-3-19-12"
}));

var SvgCherry = function SvgCherry(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCherry, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cherry.53a8c670.svg";
export { ForwardRef as ReactComponent };